<template>
  <div></div>
</template>

<script setup lang="ts">
import { useAuth } from "@scayla/core";
import { onMounted } from "vue";

import { useWorkspace } from "@/store/workspace";

const workspace = useWorkspace();

onMounted(async () => {
  workspace.clearStorage();
  await useAuth().signoutRedirect();
});
</script>
